import { createReducer, on, createFeature } from '@ngrx/store'
import { EducationState } from './education.state'
import {
  createEducation,
  createEducationFailure,
  createEducationSuccess,
  deleteEducation,
  deleteEducationFailure,
  deleteEducationSuccess,
  loadEducations,
  loadEducationsFailure,
  loadEducationsSuccess,
  updateEducation,
  updateEducationFailure,
  updateEducationSuccess
} from './education.actions'

export const initialState: EducationState = {
  educations: [],
  loading: false,
  error: null
}

export const educationReducer = createReducer(
  initialState,
  on(loadEducations, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(loadEducationsSuccess, (state, { educations }) => ({
    ...state,
    educations: educations,
    loading: false,
    error: null
  })),
  on(loadEducationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(createEducation, state => ({ ...state, loading: true })),
  on(createEducationSuccess, (state, { education }) => ({
    ...state,
    educations: [...state.educations, education],
    loading: false
  })),
  on(createEducationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(updateEducation, state => ({ ...state, loading: true })),
  on(updateEducationSuccess, (state, { education }) => ({
    ...state,
    education,
    loading: false
  })),
  on(updateEducationFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error
  })),
  on(deleteEducation, (state, { id }) => ({
    ...state,
    Educations: state.educations.map(education =>
      String(education.id) === id ? { ...education, disabled: true } : education
    )
  })),
  on(deleteEducationSuccess, (state, { id }) => {
    // Update the business state to reflect that it is successfully deleted
    const updatedState = {
      ...state,
      Educations: state.educations.filter(b => b.id !== id), // Remove the business from the list
      error: null
    }
    return updatedState
  }),
  on(deleteEducationFailure, (state, { error }) => ({
    ...state,
    error
  }))
)

// Create the feature for the business state
export const educationFeature = createFeature({
  name: 'Education', // Feature name
  reducer: educationReducer
})
export type { EducationState }
// Export the feature's selectors
export const { name, reducer, selectEducations, selectLoading, selectError } = educationFeature
